import React, { useEffect, useState } from "react";
import Container from "../components/Container";
import { Link, useLocation } from "react-router-dom";
import DeleteIcon from "../assets/images/delete-icon.svg";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableWithStickyHeader from "../components/TableWithStickyHeader";
import { Button } from "../components/Button";
import HeaderBanner from "../components/HeaderBanner";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
import useLocale from "../locales";
import i18n from "../i18n";
import { Helmet } from "react-helmet";

const History = () => {
  const { textData } = useLocale();
  const location = useLocation();
  const historyDataText = textData.historyData;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const historyDataStore =
    JSON.parse(localStorage.getItem(textData.storeData)) ?? [];
  const trimmedHistory = historyDataStore ? historyDataStore.slice(-20) : [];
  if (historyDataStore && historyDataStore.length > 20) {
    localStorage.setItem(textData.storeData, JSON.stringify(trimmedHistory));
  }
  const [historyData, setHistoryData] = useState(trimmedHistory);
  const [direction, setDirection] = useState("ltr");

  const headers = [
    historyDataText.no,
    historyDataText.name,
    historyDataText.totalInvestment,
    historyDataText.yearlyReturn,
    "",
    "",
  ];
  const cAccept = localStorage.getItem("grow-cookies");
  const cookieAccept = JSON.parse(cAccept);

  function findLastTotalInvestment(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return 0;

    for (let i = arr.length - 1; i >= 0; i--) {
      const totalInvestment = arr[i]?.totalInvestment;
      if (typeof totalInvestment === "number") {
        return totalInvestment;
      }
    }
    return 0;
  }

  useEffect(() => {
    const rtlLanguages = ["ar", "fa", "ur"];
    const currentLang = i18n.language;

    if (rtlLanguages.includes(currentLang)) {
      setDirection("rtl");
      document.documentElement.setAttribute("dir", "rtl");
    } else {
      setDirection("ltr");
      document.documentElement.setAttribute("dir", "ltr");
    }
  }, [i18n.language]);

  function getLastYearlyReturns(data) {
    if (!Array.isArray(data)) return 0;

    return data.map((array) => {
      if (Array.isArray(array) && array.length > 0) {
        const lastObject = array[array.length - 1];
        return lastObject?.yearlyReturn || 0;
      } else {
        return 0;
      }
    });
  }

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isModalOpen]);

  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setIsModalOpen(true);
  };

  const handleConfirmDelete = () => {
    const originalIndex = historyData?.length - 1 - deleteIndex;
    if (cookieAccept && analytics) {
      logEvent(analytics, "delete_report");
    }
    if (originalIndex >= 0 && originalIndex < historyData?.length) {
      const updatedHistoryData = [...historyData];
      updatedHistoryData.splice(originalIndex, 1);
      localStorage.setItem(
        textData.storeData,
        JSON.stringify(updatedHistoryData)
      );
      setHistoryData(updatedHistoryData);
      setIsModalOpen(false);
    } else {
    }
  };

  const handleCancelDelete = () => {
    setIsModalOpen(false);
  };
  const getTabName = (row) => {
    let tabName = null;

    if (Array.isArray(row) && row.length > 0 && row[0]) {
      tabName = row[0].tabName;
    } else if (row && typeof row === "object" && !Array.isArray(row)) {
      tabName = row.tabName;
    }

    if (
      tabName &&
      textData.filterDropDown &&
      textData.filterDropDown[tabName]
    ) {
      return textData.filterDropDown[tabName];
    }

    if (Array.isArray(row) && row.length > 0) {
      const firstItem = row[0];
      if (firstItem && typeof firstItem.monthlyInvestment !== "undefined") {
        return textData.filterDropDown.sipCalc || "SIP & SWP Calculator";
      } else if (
        firstItem &&
        (firstItem.investmentAmounts || firstItem.yearlyInvestment)
      ) {
        return textData.filterDropDown.lumpsumCalc || "Lumpsum Calculator";
      }
    }

    return "Investment Calculator";
  };

  // const getCalculationType = (row) => {
  //   if (
  //     Array.isArray(row) &&
  //     row.length > 0 &&
  //     row[0] &&
  //     row[0].calculationType
  //   ) {
  //     return row[0].calculationType;
  //   }
  //   return "SIP";
  // };

  return (
    <>
      <Helmet>
        <title>Instantly Download Your Financial Calculator Reports</title>
        <meta
          name="description"
          content="Quickly download your financial calculator reports in one click. Get clear insights, detailed summaries, and easy access to results for smarter planning."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://growlifefund.com/history" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Instantly Download Your Financial Calculator Reports"
        />
        <meta
          property="og:description"
          content="Quickly download your financial calculator reports in one click. Get clear insights, detailed summaries, and easy access to results for smarter planning."
        />
        <meta property="og:url" content="https://growlifefund.com/history" />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="One-click Financial Calculator report download"
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Container>
        <div className={`my-[24px] ${direction === "rtl" ? "rtl" : "ltr"}`}>
          <div className="my-[24px]">
            <HeaderBanner name={textData.History} backUrl="/" />
            <div className="overflow-x-auto pb-[20px] ">
              {historyDataStore && (
                <TableWithStickyHeader className="min-w-full ">
                  <thead className="bg-primary-bg text-left ">
                    <tr className="rounded-[8px]">
                      {headers?.map((header, index) => (
                        <th
                          key={index}
                          className={`px-[12px] py-[14px] sm:text-[16px] text-[14px] text-gray-font font-lato-regular-400  ${
                            index === 0
                              ? "rounded-l-[8px]"
                              : index === headers?.length - 1
                              ? "rounded-r-[8px]"
                              : ""
                          }`}
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-white text-left">
                    {!Array.isArray(historyData) || historyData.length === 0 ? (
                      <tr>
                        <td
                          colSpan="9"
                          className={`px-[12px] py-[14px] whitespace-nowrap sm:text-[20px] text-center text-[14px] text-black font-lato-regular-400`}
                        >
                          {historyDataText.noHistory}
                        </td>
                      </tr>
                    ) : (
                      [...historyData].reverse().map((row, index) => (
                        <tr
                          key={index}
                          className={` ${
                            index === historyData.length - 1
                              ? "border-0"
                              : "border-b"
                          } border-gray-light`}
                        >
                          <td
                            className={`px-[12px] pt-[22px] pb-[14px] whitespace-nowrap sm:text-[15px] text-[14px] text-black font-lato-regular-400`}
                          >
                            {index + 1}
                          </td>
                          <td
                            className={`px-[12px] pt-[22px] pb-[14px] whitespace-nowrap sm:text-[15px] text-[14px] text-black font-lato-regular-400`}
                          >
                            {getTabName(row)}
                          </td>
                          <td
                            className={`px-[12px] py-[14px] whitespace-nowrap sm:text-[16px] text-[14px] text-black font-lato-regular-400`}
                          >
                            {findLastTotalInvestment(row) === 0
                              ? "-"
                              : FormatIndianNumber(
                                  findLastTotalInvestment(row)
                                )}
                          </td>
                          <td
                            className={`px-[12px] py-[14px] whitespace-nowrap sm:text-[16px] text-[14px] text-black font-lato-regular-400`}
                          >
                            {getLastYearlyReturns([row]) === 0 ||
                            getLastYearlyReturns([row])[0] === 0
                              ? "-"
                              : FormatIndianNumber(
                                  getLastYearlyReturns([row])[0]
                                )}
                          </td>
                          <td className={`px-[12px] py-[14px]`}>
                            <Link
                              // In your History component, replace the logEvent call with:
                              onClick={() => {
                                const rowString = location?.state;

                                // if (rowString) {
                                const parsedData = JSON.parse(
                                  decodeURIComponent(rowString)
                                );
                                setHistoryData(parsedData);
                                localStorage.setItem(
                                  "historyData",
                                  JSON.stringify(row)
                                );
                                if (cookieAccept) {
                                  try {
                                    if (analytics && analytics.app) {
                                      logEvent(analytics, "preview_report");
                                    }
                                  } catch (error) {
                                    console.warn(
                                      "Analytics event failed:",
                                      error
                                    );
                                  }
                                }
                              }}
                              className="relative pb-[2px] whitespace-nowrap sm:text-[16px] text-[14px] bg-gradient-primary bg-clip-text text-[transparent] font-lato-regular-400 after:content-[''] after:absolute after:w-full after:h-[1px] after:bottom-0 after:left-0 after:bg-gradient-primary"
                              to={`/history/${index + 1}`}
                              state={JSON.stringify(row)}
                            >
                              {historyDataText.preview}
                            </Link>
                          </td>
                          <td className={`px-[12px] py-[14px]`}>
                            <div
                              className="cursor-pointer font-lato-regular-400 text-[16px] text-danger"
                              onClick={() => handleDeleteClick(index)}
                            >
                              {historyDataText.delete}
                            </div>
                          </td>
                        </tr>
                      ))
                    )}

                    {isModalOpen && (
                      <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50 p-[40px]">
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="max-w-[503px] overflow-auto w-full bg-white sm:p-[32px] m-[20px] p-[20px] rounded-lg shadow-lg">
                            <div className="bg-[#FC00001A] w-[100px] h-[100px] m-auto rounded-[100%]">
                              <img
                                src={DeleteIcon}
                                alt="delete-icon"
                                className="flex justify-center p-[32px]"
                              />
                            </div>

                            <div className="mt-[20px] text-black text-center m-auto sm:text-[20px] text-[18px] sm:font-lato-medium-500 font-lato-medium-500">
                              {historyDataText.deleteConfirmation}
                            </div>

                            <div className="sm:flex block justify-between w-full sm:mt-[42px] mt-[24px] gap-4">
                              <button
                                onClick={handleConfirmDelete}
                                className="text-center w-full rounded-full border border-danger transition-all bg-gradient-to-b sm:h-[48px] h-[40px] focus:outline-none"
                              >
                                <span className="flex items-center justify-center px-4 py-2 rounded-full sm:text-[18px] text-[16px] font-lato-bold-700 text-danger">
                                  {historyDataText.yesDelete}
                                </span>
                              </button>

                              <Button
                                onClick={handleCancelDelete}
                                className="w-full sm:mt-0 mt-[10px]"
                              >
                                {historyDataText.noKeep}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </tbody>
                </TableWithStickyHeader>
              )}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default History;
